import Zed from './views/zed.c';
export default Zed;
